class HeroProductCarousel extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.hero-product-carousel__item')];
    this.dots = [...this.querySelectorAll('.hero-product-carousel__dot')];
    this.prevBtn = this.querySelector('.hero-product-carousel__prev');
    this.nextBtn = this.querySelector('.hero-product-carousel__next');
    this.current = 0;
    this.interval = parseInt(this.dataset.interval) || 5000;
    this.autoplay = this.dataset.autoplay !== 'false';
    this.timer = null;

    if (this.items.length <= 1) return;

    this.prevBtn?.addEventListener('click', () => {
      this.stopAutoplay();
      this.show(this.current - 1);
      this.startAutoplay();
    });

    this.nextBtn?.addEventListener('click', () => {
      this.stopAutoplay();
      this.show(this.current + 1);
      this.startAutoplay();
    });

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.stopAutoplay();
        this.show(i);
        this.startAutoplay();
      });
    });

    if (this.autoplay) this.startAutoplay();

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  show(index) {
    const total = this.items.length;
    const next = ((index % total) + total) % total;

    this.items[this.current].classList.remove('hero-product-carousel__item--active');
    this.items[this.current].setAttribute('aria-hidden', 'true');
    if (this.dots[this.current]) {
      this.dots[this.current].classList.remove('hero-product-carousel__dot--active');
    }

    this.current = next;

    this.items[this.current].classList.add('hero-product-carousel__item--active');
    this.items[this.current].setAttribute('aria-hidden', 'false');
    if (this.dots[this.current]) {
      this.dots[this.current].classList.add('hero-product-carousel__dot--active');
    }
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.show(this.current + 1), this.interval);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('hero-product-carousel', HeroProductCarousel);
